import axiosInstance from "../axiosInstance";

export const inventoryHealthService = {
  fetchAudit: async ({ clientId, warehouseId } = {}) => {
    const params = { audit: true };
    if (clientId) params.client_id = clientId;
    if (warehouseId) params.warehouse_id = warehouseId;

    const response = await axiosInstance.get("/inventory-health", {
      params,
      suppressErrorToast: true,
    });
    return response.data;
  },

  fetchEligibleSkus: async ({
    clientId,
    warehouseId,
    search,
    limit,
    skip,
  } = {}) => {
    const params = {
      eligible_skus: true,
    };
    if (clientId) params.client_id = clientId;
    if (warehouseId) params.warehouse_id = warehouseId;
    if (search) params.search = search;
    if (limit != null) params.$limit = limit;
    if (skip != null) params.$skip = skip;

    const response = await axiosInstance.get("/inventory-health", {
      params,
      suppressErrorToast: true,
    });
    return response.data;
  },
};
